/**
 * @generated SignedSource<<5bc6f51fdd72144c7a41eaa6f1e83d9a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespShippingReturns_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespPricingGuidance_viewer">;
  readonly " $fragmentType": "PdpRespShippingReturns_viewer";
};
export type PdpRespShippingReturns_viewer$key = {
  readonly " $data"?: PdpRespShippingReturns_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespShippingReturns_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespShippingReturns_viewer",
  "selections": [
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespPricingGuidance_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "802f19f87e78f536318ca237bdc9c89c";

export default node;
